import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ReadLater",
  "use": "ReadLater-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ReadLater\"><path fill-rule=\"evenodd\" d=\"M47 46.063L31 31.53 15 46.064V8.998h32v37.064zM8 1.998V62l23-21.72L54 62V1.998H8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol